<app-workbench-page [breadcrumb]="breadcrumb">

    <section class="cw-filters cw-grid-4" [attr.aria-label]="'upgrade_summary_filters' | translate">
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="job-number">{{ "upgrade_summary_job_number" | translate }}</label>
        <input class="cw-field__control" id="job-number" type="search" [(ngModel)]="filters.jobNumber"
               [placeholder]="'upgrade_summary_job_number' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="upgrade-status">{{ "upgrade_summary_upgrade_status" | translate }}</label>
        <select class="cw-field__control" id="upgrade-status" [(ngModel)]="filters.upgradeStatus">
          <option value="">{{ "upgrade_summary_all" | translate }}</option>
          @for (status of statuses; track status) {
            <option [value]="status">{{ status }}</option>
          }
        </select>
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="year">{{ "upgrade_summary_year" | translate }}</label>
        <select class="cw-field__control" id="year" [(ngModel)]="filters.year">
          <option [ngValue]="null">{{ "upgrade_summary_all" | translate }}</option>
          @for (year of years; track year) {
            <option [ngValue]="year">{{ year }}</option>
          }
        </select>
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="site-name">{{ "upgrade_summary_site" | translate }}</label>
        <input class="cw-field__control" id="site-name" type="search" [(ngModel)]="filters.siteName"
               [placeholder]="'upgrade_summary_site' | translate" />
      </div>
      <div class="cw-filters__item cw-card cw-grid-span-2">
        <label class="cw-field__label" for="slider-min-amount">{{ "upgrade_summary_upgrade_amount" | translate }}</label>
        <div class="cw-grid cw-grid-2">
          <div>
            <label class="cw-field__label" for="slider-min-amount">{{ "upgrade_summary_min_amount" | translate }}</label>
            <input class="cw-field__control" id="slider-min-amount" type="number" min="0" step="0.01" [(ngModel)]="filters.minAmount"
                  placeholder="$" />
          </div>
          <div>
            <label class="cw-field__label" for="slider-max-amount">{{ "upgrade_summary_max_amount" | translate }}</label>
            <input class="cw-field__control" id="slider-max-amount" type="number" min="0" step="0.01" [(ngModel)]="filters.maxAmount"
                  placeholder="$" />
          </div>
        </div>
        <mat-slider class="amount-slider" discrete [min]="0" [max]="amountSliderMax" [step]="amountSliderStep"
                    [displayWith]="formatAmountLabel">
          <input matSliderStartThumb [ngModel]="filters.minAmount ?? 0" (ngModelChange)="filters.minAmount = $event"
                 [attr.aria-label]="'upgrade_summary_min_amount' | translate" />
          <input matSliderEndThumb [ngModel]="filters.maxAmount ?? amountSliderMax" (ngModelChange)="filters.maxAmount = $event"
                 [attr.aria-label]="'upgrade_summary_max_amount' | translate" />
        </mat-slider>
      </div>
    </section>
    @if (isAmountRangeInvalid) {
      <div class="cw-state cw-state--error cw-card" style="margin-bottom: 20px" role="alert">{{ "upgrade_summary_amount_range_invalid" | translate }}</div>
    }
    <section class="cw-filters cw-grid-2" [attr.aria-label]="'upgrade_summary_filters' | translate">
      <button mat-raised-button type="button" class="apply-button" [disabled]="isAmountRangeInvalid" (click)="applyFilters()">
        <mat-icon>search</mat-icon>{{ "upgrade_summary_apply" | translate }}
      </button>
      <button mat-stroked-button type="button" class="reset-filter-button" (click)="resetFilters()">
        <mat-icon>restart_alt</mat-icon>{{ "upgrade_summary_reset_filters" | translate }}
      </button>
    </section>

    @if (hasLoadError) {
      <div class="cw-state cw-state--error cw-card" role="alert">{{ "upgrade_summary_load_error" | translate }}</div>
    } @else if (!hasLoaded) {
      <div role="status" [attr.aria-label]="'upgrade_summary_loading' | translate">
        <app-skeleton layout="table" [rows]="5" [columns]="6"></app-skeleton>
      </div>
    } @else if (upgrades.length === 0) {
      <div class="cw-state cw-card" role="alert">{{ "upgrade_summary_empty" | translate }}</div>
    } @else {
      <section class="cw-table-card cw-card" [attr.aria-label]="'upgrade_summary_results' | translate">
        <div class="cw-table-card__scroll">
        <table class="cw-table" role="table">
          <thead role="rowgroup"><tr role="row">
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_upgrade_number" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_job_number" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_site" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_upgrade_status" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_upgrade_amount" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "upgrade_summary_lodged_on" | translate }}</th>
          </tr></thead>
          <tbody role="rowgroup">
            @for (upgrade of upgrades; track upgrade.id) {
              <tr class="cw-table__row" role="row">
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_upgrade_number' | translate" role="cell"><span>{{ upgrade.upgradeNumber || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_job_number' | translate" role="cell">
                  <span>{{ upgrade.jobNumber || '-' }}
                    @if (upgrade.isNavigable && upgrade.siteId && upgrade.jobId) {
                    <a class="view-job-link" [routerLink]="['/openjobs', upgrade.siteId, 'New', upgrade.jobId]"
                       [queryParams]="{ siteName: upgrade.siteName }">{{ "upgrade_summary_view_job" | translate }}</a>
                    }
                  </span>
                  
                </td>
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_site' | translate" role="cell"><span>{{ upgrade.siteName || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_upgrade_status' | translate" role="cell"><span>{{ upgrade.upgradeStatus || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_upgrade_amount' | translate" role="cell"><span>$ {{ upgrade.amount !== null ? (upgrade.amount | number:'1.2-2') : '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'upgrade_summary_lodged_on' | translate" role="cell"><span>{{ formatLodgedOn(upgrade.createdOn) }}</span></td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      </section>

    }
    @if (hasLoaded && !hasLoadError && totalCount > 0) {
      <br/>
      <mat-paginator [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons (page)="changePage($event)"></mat-paginator>
    }
</app-workbench-page>